import { render } from "./form-hidden.vue?vue&type=template&id=6658796d"
import script from "./form-hidden.vue?vue&type=script&lang=js"
export * from "./form-hidden.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__